export default __webpack_public_path__ + "static/media/padlock-red.9baab0e8.svg";